export const tracker = class {

    constructor(gtag, url) {
        this.api_url = url;
        this.gtag = gtag;
        this.nonce = fcwp_vue_data.nonce;
    }

    track(data, type = 'pageview') {
        if (typeof this.gtag === 'undefined') return;
        var method = typeof window.google_tag_manager === 'undefined' ? 'Server' : 'Browser';
        var tracking_method = 'track' + this.capitalize(type) + method;
        this[tracking_method](data);
    }

    trackPageviewBrowser(data) {
        this.gtag.trackEvent({
            event: 'pageview',
            user_id: this.nonce,
            page: {
                path: data.permalink,
                title: data.content.title,
            }
        });
    }

    trackPageviewServer(data) {
        var track_data = this.getBrowserDetails(data.language);
        track_data.t = 'pageview';
        track_data.dt = data.content.title;
        axios.post(this.api_url, track_data);
    }

    trackEventBrowser(data) {
        this.gtag.trackEvent({
            user_id: this.nonce,
            action: data.action,
            category: data.category,
            label: data.label,
            value: data.value,
        });
    }

    trackEventServer(data) {
        var track_data = this.getBrowserDetails(data.language);
        track_data.t = 'event';
        track_data.ec = data.category;
        track_data.ea = data.action;
        track_data.el = data.label;
        track_data.ev = data.value;
        axios.post(this.api_url, track_data);
    }

    getBrowserDetails(lang) {
        return {
            'sr': screen.width + 'x' + screen.height,
            'vp': Math.max(document.documentElement.clientWidth, window.innerWidth || 0) + 'x' + Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            'ul': typeof lang !== 'undefined' ? lang : null,
        }
    }

    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

}